var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { action, makeObservable, observable } from 'mobx';
import { memoize } from '../../../../../utils/mobx/decorators/memoize';
import { PlayStatus } from '../../../../learnware/LearnwareEnums';
import { runtime } from '../../../../runtime/Runtime';
export class SndHowl {
    parent;
    myHowl;
    constructor(parent) {
        makeObservable(this);
        this.parent = parent;
        this.myHowl = this.howl; // initialize
    }
    get snd() {
        return this.parent;
    }
    get shouldFallbackToHtml5Audio() {
        if (runtime.isBrowserRuntime &&
            runtime.solidBrowserRuntime.app.appInfo.isMobileAppWebView //  || runtime.solidBrowserRuntime.browserAgent.isSafari
        ) {
            // zukünftig: isWebViewInIOSApp
            // 31.12.2020: Buggy sound in ios App Web-View
            return true;
        }
        return false;
    }
    get howlSrc() {
        return [this.snd.src, this.snd.mp3Path];
    }
    get howl() {
        return new window.Howl({
            html5: this.shouldFallbackToHtml5Audio,
            src: this.howlSrc,
            mute: false,
            onload: this.onLoad,
            onloaderror: this.onLoadError,
            onplayerror: this.onError,
            onplay: this.onPlay,
            onend: this.onEnd,
            /* onpause: this.onPause,
            onstop: this.onPause,
            onunlock: this.onUnlock, */
        });
    }
    howlIntents = new Map();
    howlIds = [];
    isLoaded = false;
    loadError = '';
    howlError = '';
    get hasError() {
        return this.loadError.length > 0 || this.howlError.length > 0;
    }
    onLoad() {
        this.isLoaded = true;
    }
    onLoadError(howlId, message) {
        this.loadError = message;
        this.isLoaded = true;
        this.howlIntents.forEach(intentHandler => {
            if ([PlayStatus.Pending, PlayStatus.Go].includes(intentHandler.intent.playStatus)) {
                intentHandler.intent.playStatus === PlayStatus.Error;
            }
        });
        console.error('onLoadError', howlId, message);
    }
    onError(soundId, message) {
        this.howlError = message;
        this.isLoaded = true;
        this.howlIntents.forEach(intentHandler => {
            if ([PlayStatus.Pending, PlayStatus.Go].includes(intentHandler.intent.playStatus)) {
                intentHandler.intent.playStatus === PlayStatus.Error;
            }
        });
        console.error('onError', soundId, message);
    }
    onPlay(howlId) {
        this.howlIds.push(howlId);
        const intentHandler = this.howlIntents.get(howlId);
        if (intentHandler)
            intentHandler.onPlay();
    }
    onEnd(howlId) {
        const intentHandler = this.howlIntents.get(howlId);
        if (intentHandler)
            intentHandler.onEnd();
    }
}
__decorate([
    memoize
], SndHowl.prototype, "howl", null);
__decorate([
    observable
], SndHowl.prototype, "isLoaded", void 0);
__decorate([
    observable
], SndHowl.prototype, "loadError", void 0);
__decorate([
    observable
], SndHowl.prototype, "howlError", void 0);
__decorate([
    action.bound
], SndHowl.prototype, "onLoad", null);
__decorate([
    action.bound
], SndHowl.prototype, "onLoadError", null);
__decorate([
    action.bound
], SndHowl.prototype, "onError", null);
__decorate([
    action.bound
], SndHowl.prototype, "onPlay", null);
__decorate([
    action.bound
], SndHowl.prototype, "onEnd", null);
